import { number, shape, string, oneOfType, oneOf } from 'prop-types'

export const SHARE_DATA_SHAPE = shape({
  course: shape({
    slug: string.isRequired,
    instructorName: string.isRequired,
    id: oneOfType([number, string]).isRequired,
  }),
  chapter: shape({
    id: number,
    slug: string,
  }),
  modalImage: string,
  source: oneOf([
    // this is an incomplete list. See `SOURCES` from `@mc/share`
    'guest_pass_advocate',
    'class',
    'class_guest_next',
    'recipes',
    'pre_onboarding',
    'homepage_featured_instructor_next',
    'homepage_class_samples',
  ] as const).isRequired,
  title: string.isRequired,
})

export const LINKS_SHAPE = shape({
  facebook: string.isRequired,
  copy: string.isRequired,
  messenger: string.isRequired,
  message: string.isRequired,
  linkedin: string.isRequired,
  twitter: string.isRequired,
  email: string.isRequired,
})
